import { requestHandler } from 'lib/api';
import { Contact } from 'lib/api/contacts/types';
import { Business, Document, DocumentPublication } from 'lib/types/models';

export type PublicationDocumentInfo = Pick<
  Document,
  | 'businessIdentifier'
  | 'folio'
  | 'amount'
  | 'id'
  | 'type'
  | 'subType'
  | 'issuedDate'
>;

export type PublicationStakeholderInfo = Pick<Business, 'name' | 'identifier'>;

export type PublicationContactInfo = Pick<Contact, 'email' | 'phone'> & {
  firstName: string;
  lastName: string;
};

export async function getDocumentInfoForPublication(
  dispatch: any,
  id: string,
): Promise<
  | {
      document: PublicationDocumentInfo;
      stakeholder: PublicationStakeholderInfo;
      contactInfo: PublicationContactInfo;
      paymentDate: string | null;
    }
  | undefined
> {
  const response = await requestHandler({
    method: 'get',
    url: `internal/documentPublication/invoiceInfo/${id}`,
    dispatch,
  });
  if (response) return response.data;
}

export async function getClientInfoForPublication(
  dispatch: any,
  id: string,
): Promise<
  | {
      document: PublicationDocumentInfo & {
        businessName: string;
        paymentDate: string | null;
      };
      contactInfo: PublicationContactInfo;
    }
  | undefined
> {
  const response = await requestHandler({
    method: 'get',
    url: `internal/documentPublication/clientInfo/${id}`,
    dispatch,
  });
  if (response) return response.data;
}

type InvoicePublicationPayload = {
  document: PublicationDocumentInfo & { paymentDate: string };
  stakeholder: PublicationStakeholderInfo;
  contact: PublicationContactInfo;
};

export const publishInvoiceDebt = async (
  dispatch: any,
  data: InvoicePublicationPayload,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/documentPublication/invoice`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

type ClientPublicationPayload = {
  document: PublicationDocumentInfo & {
    businessName: string;
    paymentDate: string;
  };
  contact: PublicationContactInfo;
  cosigners: string[];
};

export const publishClientDocument = async (
  dispatch: any,
  data: ClientPublicationPayload,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/documentPublication/client`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const getPublications = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/documentPublication`,
    dispatch,
  });
  if (response) return response.data;
};

export const unpublishInvoiceDebt = async (dispatch: any, id: number) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/documentPublication/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getQueryRut = async (dispatch: any, rut: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/documentPublication/query/${rut}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getPublicationStatus = async (
  dispatch: any,
  documentId: string,
): Promise<DocumentPublication[]> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/documentPublication/status/${documentId}`,
    dispatch,
  });
  if (response) return response.data;
  return [];
};
